






















import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';
import Alternatives from '@/domain/survey/entity/alternatives.entity';

@Component({
  components: { LabelSlot },
})
export default class RadioComponent extends Vue {
  @Prop() alternatives!: Alternatives;

  @Prop() position!: number;

  @Prop() title!: string;

  @Prop() type!: string;

  @Prop() required!: boolean;

  @Prop() questionId!: string;

  rules = new Rules();

  radioGroup: any = '';

  update() {
    this.$emit('update', this.questionId, this.radioGroup)
  }
}
